import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import { SimilarAdCard } from "../../components/SimilarAdCard";
import AdList from "../../components/AdList";
import styles from "./results.scss";
import { AdCard } from "../../components/AdCard";
import { LinkTargetEnum, ModuleNameHr, PageRoute, QueryParam } from "../../models";
import { searchAds, selectResults } from "../../routes/Search/search.ducks";
import { getWindowWidth, isMobileScreen, stringifyURI } from "../../services";
import { Button } from "../../components/Button/Button";
import { Link } from "react-router-dom";
import { mapCategoryToEn } from "../../routes/LanguageMapper";



const getRandomItems = (arr, count = 8) => {
  const shuffled = [...arr];

  // Fisher-Yates shuffle algorithm
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  // Return the first 'count' items
  return shuffled.slice(0, count);

}

export const AdsOnThisLocation = (props: any) => {
  const {
    type,
    location
  } = props;

  const dispatch = useDispatch()
  const isMobile = isMobileScreen(getWindowWidth());

  const [ads, setAds] = useState(null)

  const results = useSelector(selectResults)



  // location is undefined while Results is re-resolving the url slugs
  const {
    settlementId,
    cityId,
    countyId
  } = location || {};
  const category = mapCategoryToEn(type, "real-estate")

  let locationIds = settlementId ? {
    includeSettlementIds: [settlementId]
  } : cityId ? {
    includeCityIds: [cityId]
  } : countyId ? {
    includeCountyIds: [countyId]
  } : {}


  useEffect(() => {
    if (!location) return;

    dispatch(searchAds({

      module: "real-estate",
      queryParams: {
        category,
        ...locationIds
      },
      itemPerPage: 32

    }))

  }, [location, type]);


  useEffect(() => {
    if (!results) return;

    setAds({
      ...results,
      data: getRandomItems(results.data)
    })
  }, [results])


  const containerRef = useRef(null);

  const hasAds = !!(ads && ads.data && ads.data.length >= 4);

  useEffect(() => {
    if (!hasAds) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          ReactGA.event({
            category: "Stranica prosječnih cijena nekretnina",
            action: "View",
            label: `Prikazan widget sa aktivnim oglasima`
          });
          observer.disconnect();
        }
      },
      { threshold: 0 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [hasAds]);

  const handleAdClick = () => {
    ReactGA.event({
      category: "Stranica prosječnih cijena nekretnina",
      action: "Click",
      label: `Otvoren oglas`
    });
  }

  const handleViewAllClick = () => {
    ReactGA.event({
      category: "Stranica prosječnih cijena nekretnina",
      action: "Click",
      label: `Otvoreni svi aktivni oglasi`
    });
  }

  // if ads are empty, don't display the section
  if (!location || !ads || (ads && ads.data && !(ads.data.length >= 4))) {
    return null;
  }


  return (
    <div ref={containerRef} style={{ marginTop: 30 }}>
      <div className={styles.title}>{"Trenutno aktivni oglasi na ovoj lokaciji"}</div>
      <AdList
        ads={ads ? ads.data : []}
        adCardProps={{
          hasFavorite: true,
          adLists: { search: ads || {} },
          isMobile,
          target: LinkTargetEnum.blank,
          onClick: handleAdClick
        }}
        AdCardComponent={isMobile ? AdCard : SimilarAdCard}
        responsiveProps={{ xs: 24, sm: 12, md: 12, lg: 12, xl: 8, xxl: 6 }}
        gutter={isMobile ? 0 : 20}
      />

      <div style={{
        display: "flex",
        justifyContent: "center",
        marginTop: 20
      }}>
        <Link
          target="_blank"
          to={`/${ModuleNameHr.realEstate}/${type}${PageRoute.search}${stringifyURI({ category: type, ...locationIds }, QueryParam.searchQuery)}`}
          style={{ width: "auto" }}
        >
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 6, fontWeight: "bold", textTransform: "none" }}
            onClick={handleViewAllClick}
          >
            {"Vidi cijelu ponudu"}
          </Button>
        </Link>
      </div>

    </div>
  );
}






// WEBPACK FOOTER //
// ./src/containers/RealEstatePricesPage/AdsOnThisLocation.tsx